<template>
  <div class="character-input-warning warning">
    <div
      :id="instructionId"
      class="character-input-warning__message white--text"
    >
      It seems some of the characters in your {{ fieldName }} were not rendered
      correctly. Please check and make any changes before continuing.
    </div>
  </div>
</template>

<script>
export default {
  name: "CharacterInputWarningMessage",
  props: {
    fieldName: { type: String, required: true },
    instructionId: { type: String, default: null },
  },
};
</script>

<style lang="scss">
.character-input-warning {
  border-radius: 2px;
  margin-bottom: 20px;
  &__message {
    margin: 10px;
    padding: 5px 0 5px 0;
    font-size: 14px;
  }
}
</style>
